/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function definitely(items) {
    if (!items)
        return [];
    return items.reduce(function (acc, item) { return (item ? __spreadArrays(acc, [item]) : acc); }, []);
}

var emptyResponse = [
    [],
    {
        pageInfo: {
            hasNextPage: false,
            hasPreviousPage: false,
            hasPrevPage: false,
        },
        firstCursor: undefined,
        lastCursor: undefined,
    },
];
var addCursorToEdgeNodes = function (edge) {
    if (!edge || !edge.node)
        return null;
    return __assign(__assign({}, edge.node), { __cursor: edge.cursor ? edge.cursor : undefined });
};
/**
 * unwindEdges
 * @export
 * @template EdgeType
 * @param {Paginated<EdgeType>} { edges, pageInfo }
 * @returns {UnwoundEdges<EdgeType>}
 */
var unwindEdges = function (paginated) {
    if (!paginated)
        return emptyResponse;
    var allEdges = paginated.edges || [];
    var edges = definitely(allEdges);
    var pageInfo = paginated.pageInfo;
    return [
        definitely(edges.map(addCursorToEdgeNodes)),
        {
            pageInfo: pageInfo,
            lastCursor: edges.length ? edges[edges.length - 1].cursor || undefined : undefined,
            firstCursor: edges.length ? edges[0].cursor || undefined : undefined,
        },
    ];
};

var defaultCursorKeys = ['id', '_id'];
var getCursor = function (item, cursorKey) {
    var keys = cursorKey ? __spreadArrays([cursorKey], defaultCursorKeys) : defaultCursorKeys;
    var key = keys.find(function (key) { return key in item; });
    if (key)
        return item[key];
    return undefined;
};
var itemsToEdges = function (items, config) {
    return items.map(function (node) {
        var cursor = getCursor(node, config === null || config === void 0 ? void 0 : config.cursorKey);
        return { cursor: cursor, node: node };
    });
};
var paginate = function (items, paginationArgs, config) {
    var _a, _b;
    var itemsToPaginate = (paginationArgs === null || paginationArgs === void 0 ? void 0 : paginationArgs.first) ? items.slice(0, paginationArgs.first) : items;
    var edges = itemsToEdges(itemsToPaginate, config);
    var hasNextPage = (paginationArgs === null || paginationArgs === void 0 ? void 0 : paginationArgs.first) ? items.length > paginationArgs.first : false;
    var hasPreviousPage = Boolean(paginationArgs === null || paginationArgs === void 0 ? void 0 : paginationArgs.after);
    var firstCursor = (_a = edges[0]) === null || _a === void 0 ? void 0 : _a.cursor;
    var lastCursor = (_b = edges[edges.length - 1]) === null || _b === void 0 ? void 0 : _b.cursor;
    var pageInfo = {
        hasNextPage: hasNextPage,
        hasPreviousPage: hasPreviousPage,
        hasPrevPage: hasPreviousPage,
        firstCursor: firstCursor,
        lastCursor: lastCursor,
    };
    return {
        pageInfo: pageInfo,
        edges: edges,
    };
};

export { paginate, unwindEdges };
